// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QuNtx","content":"styles_content__g6x-b","row":"styles_row__1Jgum","footer":"styles_footer__fD2V-","phraseLength":"styles_phraseLength__3WZdX"};